import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default {
  root: {
    display: 'inline-block',
    verticalAlign: 'middle',
    selectors: {
      '& .ms-Button:hover': {
        backgroundColor: 'transparent',
        color: `${theme.palette.themePrimary} !important`,
      },
    },
  },
  callout: {
    gapSpace: 0,
    calloutWidth: pxToRem(214),
    backgroundColor: theme.palette.neutralWhite,
    minPagePadding: pxToRem(16),
  },
  tooltip: {
    styles: {
      root: { backgroundColor: theme.palette.neutralWhite, padding: 0 },
      subText: {
        backgroundColor: theme.palette.neutralWhite,
        fontSize: pxToRem(12),
        padding: pxToRem(16),
      },
    },
  },
};
